import React from 'react';
import PropTypes from 'prop-types';
import { useTable, useSortBy } from 'react-table'; // useFilters
import { useSelector } from 'react-redux';
import { pathOr } from 'ramda';
import { isProgramManager, isProgramTrainer } from '@apprentage/utils';
import { TURBINE_ADMIN } from '../../../constants/urls';
import { redirectToTurbineAdmin } from '../../../services/auth';

const Table = ({ columns, data, hiddenColumns = [] }) => {
  // Redux
  const organization = useSelector((state) => state.organization);
  const currentUser = useSelector((state) => state.currentUser);
  // Organization
  const orgId = pathOr('', ['id'], organization);
  // Current User
  const role = pathOr([], ['role'], currentUser);

  const initialState = {
    sortBy: [
      {
        id: 'title',
        desc: false
      }
    ],
    hiddenColumns
  };

  const {
    getTableProps, getTableBodyProps, headerGroups, rows, prepareRow
  } = useTable(
    {
      columns,
      initialState,
      data
    },
    useSortBy
  );

  const onClickRow = (row) => {
    const { original } = row;
    const apprenticeshipId = pathOr(null, ['id'], original);

    let url = TURBINE_ADMIN;
    if (apprenticeshipId) {
      if (isProgramManager(role)) {
        url = `${TURBINE_ADMIN}/org/workforce/apprenticeships/${apprenticeshipId}?orgId=${orgId}`;
      }

      if (isProgramTrainer(role)) {
        url = `${TURBINE_ADMIN}/org/workforce/apprenticeships/${apprenticeshipId}/users?orgId=${orgId}`;
      }
    }

    document.location = redirectToTurbineAdmin(url);
  };

  return (
    <table
      className="table table-bordered m-0"
      {...getTableProps()}
    >
      <thead>
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {headerGroup.headers.map((column) => {
              return column.hideHeader ? null : (
                <th
                  style={{ verticalAlign: 'center' }}
                  {...column.getHeaderProps(column.getSortByToggleProps())}
                >
                  {column.render('Header')}
                  {column.canSort && (
                    <span className="ml-1">
                      {column.isSorted ? (
                        <>
                          {column.isSortedDesc ? (
                            <i className="fas fa-sort-down" />
                          ) : (
                            <i className="fas fa-sort-up" />
                          )}
                        </>
                      ) : (
                        <i
                          className="fas fa-sort"
                          style={{ opacity: '.25' }}
                        />
                      )}
                    </span>
                  )}
                </th>
              );
            })}
          </tr>
        ))}
      </thead>
      <tbody {...getTableBodyProps()}>
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr
              {...row.getRowProps()}
              onClick={() => {
                onClickRow(row);
              }}
              className="row-clickable"
            >
              {row.cells.map((cell) => {
                return <td {...cell.getCellProps()}>{cell.render('Cell')}</td>;
              })}
            </tr>
          );
        })}
      </tbody>
    </table>
  );
};

export default Table;

Table.propTypes = {
  data: PropTypes.arrayOf(PropTypes.shape()),
  columns: PropTypes.arrayOf(PropTypes.shape())
};
